module.exports = __webpack_public_path__ + "img/cloud4.1161b7b3.png";